import { render, staticRenderFns } from "./PackagingMaterial.vue?vue&type=template&id=a7249682&scoped=true"
import script from "./PackagingMaterial.vue?vue&type=script&lang=js"
export * from "./PackagingMaterial.vue?vue&type=script&lang=js"
import style0 from "./PackagingMaterial.vue?vue&type=style&index=0&id=a7249682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7249682",
  null
  
)

export default component.exports